import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-white to-cyan-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Get in Touch</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Have questions about our pool services? We're here to help you create and maintain your perfect pool.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <div className="space-y-8">
              <div className="flex items-start space-x-4 group">
                <div className="bg-cyan-100 rounded-full p-3 group-hover:bg-cyan-200 transition-colors duration-300">
                  <Phone className="h-6 w-6 text-cyan-600" />
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-1">Phone</h4>
                  <a 
                    href="tel:+35799562552" 
                    className="text-gray-600 hover:text-cyan-600 transition-colors duration-300"
                  >
                    +357 99 562 552
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4 group">
                <div className="bg-cyan-100 rounded-full p-3 group-hover:bg-cyan-200 transition-colors duration-300">
                  <Mail className="h-6 w-6 text-cyan-600" />
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-1">Email</h4>
                  <a 
                    href="mailto:info@aquabluecyprus.com" 
                    className="text-gray-600 hover:text-cyan-600 transition-colors duration-300"
                  >
                    info@aquabluecyprus.com
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4 group">
                <div className="bg-cyan-100 rounded-full p-3 group-hover:bg-cyan-200 transition-colors duration-300">
                  <MapPin className="h-6 w-6 text-cyan-600" />
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-1">Address</h4>
                  <p className="text-gray-600">Paphos, Cyprus</p>
                </div>
              </div>

              <div className="flex items-start space-x-4 group">
                <div className="bg-cyan-100 rounded-full p-3 group-hover:bg-cyan-200 transition-colors duration-300">
                  <Clock className="h-6 w-6 text-cyan-600" />
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-1">Working Hours</h4>
                  <div className="text-gray-600">
                    <p>Monday - Friday: 8:30 AM - 5:00 PM</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 p-6 bg-cyan-50 rounded-xl border border-cyan-100">
                <p className="text-center text-gray-700">
                  Feel free to reach out to us via phone or email. We'll get back to you as soon as possible!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 